module.exports = "/_next/static/images/decred-97c9d78980bb2f6620ba37747a60a06b.png";